// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3baq7","title":"AfterBackImages_title__zO1WF","images":"AfterBackImages_images__3I9rE"};